import FolderTreeLoadStateEnum from '../store/schema/FolderTreeLoadStateEnum';
import FolderTreeData from '../store/schema/FolderTreeData';
import Folder from 'owa-service/lib/contract/Folder';
import getMailboxFolderTreeDataTable from '../selectors/getMailboxFolderTreeDataTable';

export function setFolderTreeData(
    id: string,
    rootFolder: Folder,
    loadingState: FolderTreeLoadStateEnum,
    hasMoreData: boolean = false,
    currentLoadedIndex: number = 0
) {
    const folderTreeData: FolderTreeData = {
        id: id,
        rootFolder: rootFolder,
        loadingState: loadingState,
        hasMoreData: hasMoreData,
        currentLoadedIndex: currentLoadedIndex,
    };
    getMailboxFolderTreeDataTable().set(id, folderTreeData);
}
